"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ucFirst;

function ucFirst(str) {
  return str[0].toUpperCase() + str.substring(1);
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-tinymce/lib/helpers/ucFirst.js
// module id = 921
// module chunks = 0